export default "__VITE_ASSET__CyaO7C0D__"